(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("react-form", [], factory);
	else if(typeof exports === 'object')
		exports["react-form"] = factory();
	else
		root["react-form"] = factory();
})(this, function() {
return 